module.exports = __webpack_public_path__ + "static/media/BgImg.775aff30.jpg";